import { createMultiStyleConfigHelpers as t, extendTheme as a } from "@chakra-ui/react";
import { a as n } from "./domains-162ab8d8.js";
import { f as i, g as l, i as s } from "./@chakra-ui-f377b543.js";
const d = l(({ colorScheme: e }) => e === "brand" ? {
  bg: "brand.black",
  border: "none",
  color: "white",
  px: 5,
  py: 3,
  borderRadius: "lg",
  fontWeight: "bold",
  lineHeight: "base",
  minH: 12,
  _hover: {
    bg: "brand.neutral.deeper",
    _disabled: {
      bg: "brand.neutral.bright"
    }
  },
  _disabled: {
    // bg: 'brand.neutral.bright',
    bg: "#E6E6EB",
    // color: 'brand.neutral.deep',
    color: "#A5AAAF",
    borderColor: "brand.neutral.deep",
    opacity: 1
  }
} : {}), b = i({
  variants: { solid: d },
  defaultProps: {
    colorScheme: "brand"
  }
}), { definePartsStyle: o, defineMultiStyleConfig: c } = t(
  s.keys
), m = o({
  field: {
    paddingX: "12px",
    paddingY: "17.5px",
    height: {
      md: "56px"
    },
    _placeholder: {
      color(e) {
        return e.colors.brand.neutral.deeper;
      }
    }
  }
}), p = o({
  field: {
    borderColor(e) {
      return e.colors.brand.neutral.deep;
    },
    _hover: {
      borderColor(e) {
        return e.colors.brand.neutral.deeper;
      }
    }
  }
}), g = {
  ...c({
    baseStyle: m,
    variants: {
      outline: p
    }
  }),
  defaultProps: {
    focusBorderColor: "brand.black"
  }
}, h = {
  initialColorMode: "light",
  useSystemColorMode: !1
}, f = {
  global: {
    html: {
      // height: '100%',
      scrollBehavior: "smooth",
      colorScheme: "only light !important",
      overscrollBehavior: "none",
      WebkitTapHighlightColor: "rgba(255, 255, 255, 0)"
    },
    body: {
      bg: "#FFFFFF",
      overscrollBehavior: "none",
      color: "primaryText"
    },
    ":root": {
      colorScheme: "only light !important"
    }
  }
}, r = n(), F = a({
  config: h,
  styles: f,
  fonts: {
    heading: r === "maxis" ? "Maxis, sans-serif" : r === "starhub" ? "Lato, sans-serif" : r === "jbhifi" ? "Apercu Pro" : "sans-serif",
    // TODO: Replace font conditions
    body: r === "maxis" ? "Maxis, sans-serif" : r === "starhub" ? "Lato, sans-serif" : r === "jbhifi" ? "Apercu Pro" : "sans-serif"
  },
  semanticTokens: {
    colors: {
      "chakra-body-text": {
        _light: "#000000"
      },
      brand: {
        valid: "#008662",
        invalid: "#DB1B1B"
      }
    }
  },
  colors: {
    primary: { 500: "#8223D2" },
    onPrimary: { 500: "#8223D2" },
    // Change to scale instead?
    brand: {
      border: "#D5D6DA",
      black: "#000000",
      tertiary: "#333333",
      secondary: "#6E767D",
      bg: "#F0F0F5",
      neutral: {
        deep: "#A5AAAF",
        deeper: "#6E767D",
        bright: "#E6E6EB",
        brightest: "#F0F0F5"
      }
    }
  },
  components: {
    Input: g,
    Button: b,
    Container: {
      baseStyle: {
        maxW: "container.sm"
      }
    },
    Code: {
      baseStyle: {
        padding: "16px",
        fontSize: "xs"
      }
    },
    Heading: {
      variants: {
        storyTitle: {
          color: "primary.500",
          fontSize: "3xl",
          fontWeight: 700
        }
      }
    },
    Text: {
      defaultProps: {
        color: "primaryText"
      },
      variants: {
        storyField: {
          fontSize: "large",
          color: "primary.500",
          textAlign: "left"
        }
      }
    }
  },
  breakpoints: {
    base: "0em",
    // 0px
    xsm: "23.4375em",
    // 375px
    sm: "30em",
    // ~480px. em is a relative unit and is dependant on the font-size.
    md: "48em",
    // ~768px
    lg: "62em",
    // ~992px
    xl: "80em",
    // ~1280px
    "2xl": "96em"
    // ~1536px
  }
});
export {
  F as t
};
